"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _Flag = _interopRequireDefault(require("../Layout/Flag/Flag"));

var _Warning = _interopRequireDefault(require("../Icons/Warning"));

var _Success = _interopRequireDefault(require("../Icons/Success"));

var _Info = _interopRequireDefault(require("../Icons/Info"));

var _theming = require("../../theming");

var _themeContants = require("../../constants/themeContants");

var _ThemeComponent = _interopRequireDefault(require("../Theme/ThemeComponent"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var tProps = {
  alert: {
    name: "ALERT",
    description: "Alert style",
    type: _themeContants.themePropTypes.style
  },
  componentAlertInfo: {
    name: "COMPONENT_ALERT_INFO",
    description: "Theme component for info alert",
    type: _themeContants.themePropTypes.component
  },
  componentAlertWarning: {
    name: "COMPONENT_ALERT_WARNING",
    description: "Theme component for warning alert",
    type: _themeContants.themePropTypes.component
  },
  componentAlertSuccess: {
    name: "COMPONENT_ALERT_SUCCESS",
    description: "Theme component for success alert",
    type: _themeContants.themePropTypes.component
  },
  alertInfo: {
    name: "ALERT_INFO",
    description: "Styles for info alert",
    type: _themeContants.themePropTypes.style
  },
  alertWarning: {
    name: "ALERT_WARNING",
    description: "Styles for warning alert",
    type: _themeContants.themePropTypes.style
  },
  alertSuccess: {
    name: "ALERT_SUCCESS",
    description: "Styles for success alert",
    type: _themeContants.themePropTypes.style
  }
};

var Icon = function Icon(_ref) {
  var type = _ref.type,
      props = _ref.props;

  switch (type) {
    case "info":
      return _react["default"].createElement(_ThemeComponent["default"], _extends({
        tagName: tProps.componentAlertInfo,
        fallback: _Info["default"]
      }, props));

    case "warning":
      return _react["default"].createElement(_ThemeComponent["default"], _extends({
        tagName: tProps.componentAlertWarning,
        fallback: _Warning["default"]
      }, props));

    case "success":
      return _react["default"].createElement(_ThemeComponent["default"], _extends({
        tagName: tProps.componentAlertSuccess,
        fallback: _Success["default"]
      }, props));

    default:
      return null;
  }
};

var colors = function colors(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case "warning":
      return (0, _styledComponents.css)(["background-color:", ";color:", ";", ";"], (0, _theming.color)("warning"), (0, _theming.color)("white"), (0, _theming.applyVariants)(tProps.alertWarning));

    case "success":
      return (0, _styledComponents.css)(["background-color:", ";color:", ";", ";"], (0, _theming.color)("positive"), (0, _theming.color)("white"), (0, _theming.applyVariants)(tProps.alertSuccess));

    case "info":
    default:
      return (0, _styledComponents.css)(["background-color:", ";color:", ";", ";"], (0, _theming.color)("line"), (0, _theming.color)("text"), (0, _theming.applyVariants)(tProps.alertInfo));
  }
};

var Alert = function Alert(_ref3) {
  var children = _ref3.children,
      type = _ref3.type,
      restProps = _objectWithoutProperties(_ref3, ["children", "type"]);

  if (!children) {
    // TODO: What do we do here
    _loglevel["default"].warn("No children defined");

    return null;
  }

  return _react["default"].createElement(AlertElement, _extends({
    type: type,
    role: "alert"
  }, restProps), _react["default"].createElement(_Flag["default"], {
    small: true,
    img: _react["default"].createElement(Icon, {
      type: type
    })
  }, children));
};

var AlertElement = _styledComponents["default"].div.withConfig({
  displayName: "Alert__AlertElement",
  componentId: "sc-56pfri-0"
})(["width:100%;border-radius:", ";padding:", ";", ";", ";"], _theming.borderRadius, _theming.spacing.small, colors, (0, _theming.applyVariants)(tProps.alert));

Alert.propTypes = {
  /**
   * Component or text to render inside the alert
   */
  children: _themeContants.commonPropTypes.children.isRequired,

  /**
   * Alert type
   * @export
   */
  type: _propTypes["default"].oneOf(["warning", "success", "info"])
};
Alert.defaultProps = {
  type: "info",
  children: null
};
Alert.themeProps = tProps;
var _default = Alert;
exports["default"] = _default;